/*
 * Keeps the --header-height custom properties in sync with the rendered header,
 * and sizes the search modal to sit below it.
 *
 * Every lookup below is optional: the header markup varies by section settings
 * (top-menu vs bottom-menu, search enabled or not), and the search modal is only
 * present on some templates. Measuring a missing node used to throw
 * "getComputedStyle: parameter 1 is not of type 'Element'" out of the
 * ResizeObserver callback on most routes, which aborted the callback before the
 * search offset was ever written.
 */
(() => {
	const px = (value) => `${value}px`;

	const measureSearchModal = () => {
		const searchModal = document.querySelector('details-modal.header__search > details');
		if (!searchModal) return;

		const searchForm = searchModal.querySelector('predictive-search');
		const searchContent = searchModal.querySelector('.search__content');
		const searchInner = searchModal.querySelector('.search__modal');
		if (!searchForm || !searchContent || !searchInner) return;

		const searchFormHeight = searchForm.getBoundingClientRect().height || 0;
		const paddingTopSearch = parseInt(getComputedStyle(searchContent).paddingTop, 10) || 0;
		const marginTopInner = parseInt(getComputedStyle(searchInner).marginTop, 10) || 0;

		searchModal.style.setProperty('--top-search-height', px(searchFormHeight + paddingTopSearch + marginTopInner));
	};

	const calcHeader = () => {
		const header = document.querySelector('.shopify-section-header');
		if (!header) return;

		if (window.headerObserver) window.headerObserver.disconnect();

		window.headerObserver = new ResizeObserver(() => {
			const headerHeight = header.getBoundingClientRect().height;
			const headerHeightTop = header.querySelector('.header__top')?.getBoundingClientRect().height || 0;
			const headerHeightBottom = header.querySelector('.header__inline-menu')?.getBoundingClientRect().height || 0;
			const headerWrapper = header.querySelector('.header-wrapper');
			const isBottomMenu = !!headerWrapper
				&& headerWrapper.classList.contains('header-wrapper--bottom-menu')
				&& !headerWrapper.classList.contains('header-wrapper--full-width');

			if (isBottomMenu) {
				document.documentElement.style.setProperty('--header-height', px(headerHeightTop + headerHeightBottom + 16 - 4));
			} else {
				document.documentElement.style.setProperty('--header-height', px(headerHeight));
			}

			document.documentElement.style.setProperty('--header-height-top', px(headerHeightTop));
			document.documentElement.style.setProperty('--header-height-bottom', px(headerHeightBottom - 4));

			measureSearchModal();
		});

		window.headerObserver.observe(header);
	};

	calcHeader();

	document.addEventListener('shopify:section:load', calcHeader);
	document.addEventListener('shopify:section:unload', calcHeader);
	document.addEventListener('shopify:section:reorder', calcHeader);
})();
